import { PlainButton } from "@jugl-web/ui-components";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { ReactComponent as BackIcon } from "./assets/back.svg";

export const CXWorkspaceSettingsTopbar = () => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();
  const handleBack = () => navigateToPage("clientSupport");

  return (
    <div className="flex h-[60px] items-center gap-2 border-x-0 border-t-0 border-b border-solid border-dark-200 bg-white px-2.5 text-dark">
      <PlainButton
        onClick={handleBack}
        className="flex items-center justify-center rounded-md p-2.5 text-dark transition-colors hover:bg-[#F9F9F9]"
      >
        <BackIcon />
      </PlainButton>
      <span className="font-secondary text-lg font-medium">
        {t({
          id: "cx-workspace-settings.back-to-workspace",
          defaultMessage: "Back to Workspace",
        })}
      </span>
    </div>
  );
};
